// Utils
import cn from '../../../utils/cn';

// Components
import Picto from '../../atoms/Picto/Picto';

// Styles
import styles from './NavigationButton.module.css';

/**
 * @typedef {'previous' | 'next'} NavigationButtonDirection
 */

/**
 * @typedef {object} NavigationButtonProps
 * @property {NavigationButtonDirection} direction - Navigation direction
 * @property {() => void} onClick - Click handler
 * @property {string} [label] - Aria label for the button
 * @property {boolean} [disabled=false] - Disable the button
 * @property {string} [className] - Additional CSS classes
 */

const defaultLabels = {
  previous: 'Previous',
  next: 'Next',
};

/**
 * NavigationButton - Single navigation chevron button
 * @param {NavigationButtonProps} props - The component props
 * @returns {JSX.Element} The NavigationButton component
 */
function NavigationButton({
  direction,
  onClick,
  label,
  disabled = false,
  className = '',
}) {
  const icon = direction === 'previous' ? 'chevron-left-linear' : 'chevron-right-linear';

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label || defaultLabels[direction]}
      className={cn([
        styles['navigation-button'],
        className,
      ])}
    >
      <Picto icon={icon} className={styles.icon} />
    </button>
  );
}

export default NavigationButton;
